import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Hey developers, pay attention - it's time to step up your game. The latest AI tools are taking over, and you don't wanna be left in the dust. But don't worry, we got you covered with our online conference, featuring TOP experts dropping knowledge bombs in killer talks and panel discussions. We're talking a stacked lineup of 13 speakers, 3 panels, startup spotlights, Q&A sessions, certificates, and some spicy chats in the event forum.</p>
                            <p className="concept-text p1">This isn't your typical online course, my friends. This is a community-driven conference where seriously cool people come together to share their experience and best practices. And with over 1000 participants expected to join from all over the globe, you know this event is gonna be hot.</p>
                            <p className="concept-text p1">Our event organizer has been killing it with over 50 successful events in the past three years, and we're bringing in the big guns for this one. Our speakers come from the most renowned brands and biggest open source projects, ready to share their fresh use cases and insights.</p>
                            <p className='concept-text concept-text--bold p1'>So, if you wanna stay ahead of the curve with the latest AI tools in software development, you gotta hit that button and join our community. Let's make moves and level up our skills together!</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;